import React from 'react';
import Header from '../common/header';
import Side from '../common/side';
import Main from './main';
import Footer from './footer';
import '../../css/settingSiteSearch.css';
import axios from "axios";
import {apiURLSiteSearch, apiURLFullTextSearch, apiURLSettingSiteSearch} from '../../utils/constants'

//デザインを未選択の状態
const SEARCH_FORM_DESIGN_NOT_SELECT = 0

class App extends React.Component {

  //コンストラクター
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      totalstep: 1,
      steptitle: {
        1: "検索優先度の設定",
      },
      contenttitle: {
        1: "検索優先度の設定をしてください",
      },
      //検索結果の表示件数
      dispSearchNum: 10,
      keyDownEscFlag: false,
      //対象ドメイン
      searchdomain: "",
      //キーワード
      keyword: "",
      //検索結果のリスト
      searchResultList: [],
      //検索結果のセレクトボックス
      searchResulSelectBox: [],
      //ページ数
      pagenum: 0,
      //全要素数
      totalnum: 0,
      //現在のページ位置
      currentPage: 1,
      //モーダル表示フラグ(true:表示、false:非表示)
      isDispModal: false,
      //検索結果の表示フラグ(true:表示、false:非表示)
      isDispSearchList: false,
      //検索結果の表示タイプ(0:URL表示、1:タイトル表示)　※デフォルトは、URL表示
      isURLDisp: 0,
      //そのページのセレクトボックス変更内容を「保存」ボタンを押下して反映した否かのフラグ　※反映前にページネーションを行わないようにするため
      isSelectBoxChange: false,
      //検索順位
      searchRanking: {},
      //モーダルのエラーメッセージ内容
      modalErrorMessage: "",
      //BiNDに対するコールバック
      callback: "",
      //BiNDに対するconfig
      config: "",
      //a
      a: "",
      //t
      t: ""
    };

    console.log("init App's state")
    console.log(this.state)
  }

  //コンポーネントマウント時
  async componentDidMount(){

    // bind側のパラメータ取得
    let data = window.location.hash.replace("#/SettingSiteSearch","");
    data = data.slice(1).split('&');

    const query = {};
    for(let i=0; i < data.length; i++){
        let cdata = data[i].split('=');
        query[cdata[0]] = cdata[1];
    }
    console.log(query)

    let callback = decodeURIComponent(query.callback);
    let config = decodeURIComponent(query.config);
    let a = decodeURIComponent(query.a)
    let t = decodeURIComponent(query.t)

    //サイト内検索情報取得
    await this.getSearchInfo(a,t)
    //BiND情報更新
    this.updateBiNDInfo(callback,config,a,t)
  }

  //サイドセクションのステップ+1更新
  async save() {

    //次のステップに行く前にバリデーション処理を行う。
    let　errorMessage = ""
    //let　errorMessage = this.validateInput()

    if(errorMessage == ""){
      await this.saveSearchRanking()
    }else{
      //モーダルを表示
      this.setState({
         isDispModal: true,
         modalErrorMessage: errorMessage
      });
    }

  }

  //検索ボタンを押下時
  async search(keyword,pageid) {

      const AXIOS_RTN_OK = "OK"

      console.log(keyword)

      try {

        const data = {
          keyword: keyword,
          dispSearchNum: this.state.dispSearchNum,
          pageid: pageid,
          a: this.state.a,
          t: this.state.t
        }

        const strdata = JSON.stringify(data);

        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

        //検索結果を取得
        const res = await axios.post(apiURLFullTextSearch,strdata)
        console.log(res)
        if(res.statusText == AXIOS_RTN_OK){

          let searchResultList = res.data.dataset
          let selectBoxArray = []
          let subSelectBoxArray = []

          //セレクトボックス
          for(let i=0; i<searchResultList.length; i++){
            subSelectBoxArray = []
            subSelectBoxArray.push(searchResultList[i].page_url)
            subSelectBoxArray.push(searchResultList[i].word_rank)
            selectBoxArray.push(subSelectBoxArray)
          }

          console.log(selectBoxArray)

          //データを更新
          this.setState({
            searchResultList: res.data.dataset,
            pagenum: res.data.pagenum,
            totalnum: res.data.totalnum,
            currentPage: pageid,
            isDispSearchList: true,
            searchResulSelectBox: selectBoxArray
          });
        }
        
      }catch(err) {
        console.log(err)
      }
  }
  
  //検索結果の表示形式を更新
  updateDispType(value) {

    //URL表示
    const URL_DISP = 0
    //タイトル表示
    const TITLE_DISP = 1

    if(value == URL_DISP){
      this.setState({ isURLDisp: URL_DISP });    
    }else{
      this.setState({ isURLDisp: TITLE_DISP });    
    }
  }

  //二重押し防止
  updateKeyDownEscFlag(bvalue) {
    this.setState({ keyDownEscFlag: bvalue });    
  }

  //対象ドメインの更新
  updateKeyWord(keyword) {
    this.setState({ keyword: keyword });
  }

  //セレクトボックスの更新
  updateSelectBox(name, value) {

    const PAGE_URL_INDEX = 0
    const WORD_RANK_INDEX = 1

    let name_num = Number(name)
    let searchResulSelectBox_temp = this.state.searchResulSelectBox
    searchResulSelectBox_temp[name][WORD_RANK_INDEX] = value
    console.log(searchResulSelectBox_temp)

    this.setState({ 
      searchResulSelectBox: searchResulSelectBox_temp,
      isSelectBoxChange: true 
    });
  }

  updateIsDispModal(errorMessage) {
      //モーダルを表示
      this.setState({
        isDispModal: true,
        modalErrorMessage: errorMessage
     }); 
  }

  //モーダルを閉じる
  closeModal() {
    this.setState({ isDispModal: false });
  }

  //BiNDに対するコールバック
  updateBiNDInfo(callback,config,a,t) {
    this.setState({
      callback: callback,
      config: config,
      a: a,
      t: t
    });
  }

  //各ステップの入力検証
  validateInput(){

    let errorMessage = ""

    //ステップ１の場合
    if(this.state.step == 1){
      //必須チェック
      if(this.state.searchdomain == ''){
        errorMessage = "セレクトボックスの変更を「保存」ボタンを押して反映してください。"
        return errorMessage
      }
    }

    return errorMessage
  }

  //サイト内検索情報取得
  async getSearchInfo(a,t){

    try {

      const data = {
        a: a,
        t: t
      }
      const strdata = JSON.stringify(data);

      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

      //情報を取得
      const res = await axios.post(apiURLSiteSearch,strdata)
      console.log(res)

      //処理が上手くいった場合
      if(res.data.success == true){
        //search_info.domainの文字の長さが0でない場合　※ドメインの中身のみ確認すればOK
        if( 0 != Object.keys(res.data.search_info.domain).length){
          this.setState({
            searchdomain: res.data.search_info.domain,
            dispSearchNum: res.data.search_info.disp_searchnum,
          });
        }
      }else{
        console.log('server error getSearchInfo')
      }

    }catch(err){
      console.log(err)
    }
  }

	//検索順位の保存
  async saveSearchRanking(){

    try {

      const data = {
        keyword: this.state.keyword,
        searchResulSelectBox: this.state.searchResulSelectBox,
        a: this.state.a,
        t: this.state.t
      }
      const strdata = JSON.stringify(data);

      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

      //DBへ登録する。
      const res = await axios.post(apiURLSettingSiteSearch,strdata)
      console.log(res)
      if(res.data.success == true){

        //bindに引継ぎ
        const json = JSON.parse(this.state.config)
        //json.isDispOgImage = this.state.isDispOgImage

        //完了
        window.location.href = this.state.callback 
          +'&config=' + encodeURIComponent(JSON.stringify(json))
      }
       
    }catch(err) {
      console.log(err)
    }
  }

  render() {
    return (
      <div>
        <div>{this.state.nextstep}</div>
        <Header />
        <Side 
          step={this.state.step}
          totalstep={this.state.totalstep}
          steptitle={this.state.steptitle}
        />
        <Main
          step={this.state.step}
          contenttitle={this.state.contenttitle}
          searchdomain={this.state.searchdomain}
          keyword={this.state.keyword}
          searchResultList={this.state.searchResultList}
          searchResulSelectBox={this.state.searchResulSelectBox}
          pagenum={this.state.pagenum}
          currentPage={this.state.currentPage}
          totalnum={this.state.totalnum}
          isDispModal={this.state.isDispModal}
          isDispSearchList={this.state.isDispSearchList}
          isURLDisp={this.state.isURLDisp}
          isSelectBoxChange={this.state.isSelectBoxChange}
          modalErrorMessage={this.state.modalErrorMessage}
          updateKeyWord={(keyword) => { this.updateKeyWord(keyword); }}
          search={(keyword,pageid) => { this.search(keyword,pageid); }}
          updateDispType={(value) => { this.updateDispType(value); }}
          updateSelectBox={(name,value) => { this.updateSelectBox(name,value); }}
          updateIsDispModal={(errorMessage) => { this.updateIsDispModal(errorMessage); }}
          closeModal={() => { this.closeModal(); }}
        />
        <Footer
          step={this.state.step}
          totalstep={this.state.totalstep}
          keyDownEscFlag={this.state.keyDownEscFlag} 
          callback={this.state.callback} 
          save={() => { this.save(); }}
          updateKeyDownEscFlag={(bvalue) => { this.updateKeyDownEscFlag(bvalue); }}
        />
      </div>
    );
  }
}

export default App;